// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__gl8Ls","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2lP25"};